<script setup>
import EQRCCommunity from "../../../assets/images/QTEdu-logo-colors@2x.png";
</script>
<template>
  <div>
    <h1 class="heading1 !normal-case">
      Europe´s Quantum Technology Education Community
      <hr class="gradientLine" />
    </h1>
    <div class="flex k1:flex-row flex-col gap-2 p-8 bg-slate-100 text-justify">
      <div class="k1:columns-2 columns-1">
        <h2 class="gradientText heading2 !mb-0 pb-4 w-fit">QTEdu</h2>
        QTEdu ran from 2020-2022 with the aim being to assist the European
        Quantum Flagship in creating the learning ecosystem necessary to inform
        and educate society about quantum technologies. The goal is for a
        quantum-ready society, with knowledge about and positive attitudes
        towards quantum technologies, to enable the emergence of a quantum-ready
        workforce. The QTEdu CSA Project was funded by the European Union’s
        Horizon 2020 research and innovation programme under grant agreement
        number 951787.
        <br />
        <br />
        To do so, QTEdu coordinated a community effort needed for an immense
        scaling-up in training and education while increasing
        interdisciplinarity and drawing acute attention to current and future
        corporate and societal needs. It significantly advanced the development
        of a European Quantum Technology Education community, though five
        structured working groups:
        <div class="flex-shrink-0 items-center k1:p-4 flex flex-col">
          <div class="w-fit flex-grow">
            <img :src="EQRCCommunity" alt="" class="float-right pt-16 pb-10" />
          </div>
          <ol class="list-decimal k1:px-4 px-2 pb-4">
            <li>School education and Public Outreach</li>
            <li>Educational Initiatives in Higher Education</li>
            <li>Lifelong learning and workforce training</li>
            <li>Educational research in Quantum Technology</li>
            <li>Equity and Inclusion for QT Educational Initiatives</li>
          </ol>
          <p>
            Which self-organised into
            <a
              href="https://qtedu.eu/qtedu-european-pilot-projects"
              class="text-blue-500 gradientText hoverUnderline"
            >
              11 innovative pilot projects.
            </a>
          </p>
          <button
            class="mt-4 button main"
            @click="
              () => $router.push(`/education&training/resources-qt-community`)
            "
          >
            <!--                Click here to know more-->
            Resources
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
